import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { images } from '../../data/images';
import { demoHouse } from '../../data/demoHouse';
import { demoUsage } from '../../data/demo';
import { products } from '../../data/products';
import { computeAdvice, estimateUsage, recommendProduct } from '../../utils/energy';
import { HOUSE_TYPE_LABELS, LABEL_COLORS } from '../../utils/house';
import { euro, num } from '../../utils/format';
const steps = [{
  title: 'We vinden je huis',
  text: 'Via je adres halen we bouwjaar, oppervlak en de exacte contour uit de BAG.'
}, {
  title: 'We meten je dak',
  text: 'Op de luchtfoto berekenen we dakoppervlak en ruimte voor zonnepanelen.'
}, {
  title: 'Jij krijgt je advies',
  text: 'Welke batterij past, wat hij oplevert en wanneer hij zich terugverdient.'
}];
const usage = {
  ...demoUsage,
  annualUsage: estimateUsage(demoUsage)
};
const product = recommendProduct(usage, products);
const advice = computeAdvice(usage, product);
export function ScanTeaser() {
  return <section className="bg-forest-deep text-canvas" data-id="element-270" data-mp="1k65w3c3x5rbl">
      <div className="mx-auto grid max-w-[1440px] gap-14 px-4 py-24 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-24 lg:px-10 lg:py-32" data-id="element-271" data-mp="1f7kvvcoo37n5">
        <div data-id="element-272" data-mp="1aauhctsigk3u">
          <p className="text-[15px] font-medium text-volt" data-id="element-273" data-mp="1aam0kqt9ound">De Stroomkluis huisscan</p>
          <h2 className="mt-3 text-4xl font-semibold leading-[1.04] tracking-tightest sm:text-5xl lg:text-[56px]" data-id="element-274" data-mp="1698viiy00vhi">
            Jouw huis, gemeten
            <br className="hidden sm:block" data-id="element-275" data-mp="wh34bbfkmi3d" /> <span className="text-canvas/55" data-id="element-276" data-mp="wfrzr9eax6b7">vanuit de lucht.</span>
          </h2>
          <ol className="mt-10 space-y-7" data-id="element-277" data-mp="rj1msuxsmqu0">
            {steps.map((s, i) => <li key={s.title} className="grid grid-cols-[40px_1fr] gap-4" data-id="element-278" data-mp="mjyijcpn0on3" data-mpi={i}>
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-canvas/25 font-display text-[15px] font-semibold" data-id="element-279" data-mp="ihby3wvaq5zx">
                  {i + 1}
                </span>
                <div className="pt-1.5" data-id="element-280" data-mp="3v4qygkl5mw6">
                  <h3 className="text-lg font-semibold" data-id="element-281" data-mp="3tbjiz25eyn4">{s.title}</h3>
                  <p className="mt-1 max-w-md text-[15px] leading-relaxed text-canvas/65" data-id="element-282" data-mp="7wqd6sj0fdj1">{s.text}</p>
                </div>
              </li>)}
          </ol>
          <div className="mt-10 flex flex-wrap gap-3" data-id="element-283" data-mp="3v16733jer6oo">
            <Link to="/scan?demo=1" className="inline-flex items-center gap-2 whitespace-nowrap rounded-xl bg-volt px-6 py-4 text-[16px] font-semibold text-ink transition-colors duration-150 hover:bg-volt-deep" data-id="element-284" data-mp="3v1z8rq3if5zy">
              Bekijk de demo-scan <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-285" data-mp="cwcqf1yu8tru" />
            </Link>
            <Link to="/scan" className="inline-flex items-center whitespace-nowrap rounded-xl border border-canvas/25 px-6 py-4 text-[16px] font-medium text-canvas transition-colors duration-150 hover:bg-canvas/10" data-id="element-286" data-mp="hu4flo83m1sc">
              Eigen adres scannen
            </Link>
          </div>
        </div>

        <div className="relative aspect-[4/3] overflow-hidden rounded-[28px] bg-forest" data-id="element-287" data-mp="2uzsz7owi35iw">
          <img src={images.aerial} alt="Luchtfoto van een woonwijk met zonnepanelen" className="absolute inset-0 h-full w-full object-cover" data-id="element-288" data-mp="2q1hs3lxlb94d" />
          <div className="absolute inset-0 bg-ink/25" aria-hidden="true" data-id="element-289" data-mp="33vijtvq4jvv8" />
          <svg viewBox="0 0 400 300" className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-290" data-mp="2zsvv43or2r29">
            <polygon points="178,118 232,110 238,166 184,174" fill="rgba(212,245,90,0.3)" stroke="#D4F55A" strokeWidth="2.5" strokeLinejoin="round" data-id="element-291" data-mp="2c2rsnznasxcu" />
            <circle cx="208" cy="142" r="4" fill="#fff" stroke="#0B1D17" strokeWidth="2" data-id="element-292" data-mp="2l3pp9wveq2le" />
          </svg>
          <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-id="element-293" data-mp="2g3ttgkwv5hgx">
            <div className="scan-line absolute inset-x-0 top-0 h-[18%] border-b-2 border-volt/80 bg-volt/10" data-id="element-294" data-mp="c5yuw5bo11a" />
          </div>

          <div className="absolute left-4 top-4 rounded-2xl bg-canvas px-4 py-3 text-ink shadow-lg sm:left-6 sm:top-6" data-id="element-295" data-mp="3riqk1z8p4eqe">
            <div className="text-[12px] text-ink-muted" data-id="element-296" data-mp="qq5ejidut3qi">Gevonden in de BAG</div>
            <div className="mt-0.5 flex items-center gap-2 text-[15px] font-semibold" data-id="element-297" data-mp="vnnl524ef6vc">
              {demoHouse.street} {demoHouse.houseNumber}, {demoHouse.city}
              <span className="rounded px-1.5 py-0.5 text-[12px] font-semibold text-white" style={{
              backgroundColor: LABEL_COLORS[demoHouse.energyLabel]
            }} data-id="element-298" data-mp="15llbbv5tjdql">
                {demoHouse.energyLabel}
              </span>
            </div>
          </div>

          <dl className="absolute inset-x-4 bottom-4 grid grid-cols-3 divide-x divide-line rounded-2xl bg-canvas text-ink shadow-lg sm:inset-x-6 sm:bottom-6" data-id="element-299" data-mp="1ejwyfn7h7tea">
            <div className="p-4" data-id="element-300" data-mp="1oarmmx4a932d">
              <dt className="text-[12px] text-ink-muted" data-id="element-301" data-mp="1odvx2c8ccv1h">{HOUSE_TYPE_LABELS[demoHouse.houseType]}</dt>
              <dd className="mt-0.5 font-display text-lg font-semibold sm:text-xl" data-id="element-302" data-mp="1t8t4jepz2wc9">{num(demoHouse.roofArea)} m² dak</dd>
            </div>
            <div className="p-4" data-id="element-303" data-mp="3hv1l9dl59p4w">
              <dt className="text-[12px] text-ink-muted" data-id="element-304" data-mp="3hvbct5lu84cp">Ruimte voor</dt>
              <dd className="mt-0.5 font-display text-lg font-semibold sm:text-xl" data-id="element-305" data-mp="3dsosrqvernq2">{demoHouse.panelPotential} panelen</dd>
            </div>
            <div className="p-4" data-id="element-306" data-mp="38u3s5qc8v213">
              <dt className="text-[12px] text-ink-muted" data-id="element-307" data-mp="33uqwcg3eakmd">Advies: {product.name}</dt>
              <dd className="mt-0.5 font-display text-lg font-semibold text-forest-light sm:text-xl" data-id="element-308" data-mp="33x3kjazqxr7v">{euro(advice.savingsTotal)}/jr</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>;
}